import { ExportOutlined, PlusOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  EXPORT_TYPES,
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import ResetFilterButton from '../../../../../components/ResetFilterButton';
import { REQUEST_USER_EXPORT } from '../../../graphql/Mutations';
import StaffTable from '../components/StaffTable';
import {
  LIBRARY_STAFF_BASE_PATH,
  LIBRARY_STAFF_TABLE_FILTER_KEY,
  STAFF_ROLE_KEYS,
} from '../staffConfig';

const Staff = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const history = useHistory();
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestUserExport] = useMutation(REQUEST_USER_EXPORT, {
    onError: () => {},
  });

  const canCreate = hasPermission(
    PERMISSIONS_KEY?.SYSTEM_USERS_ADMINS,
    PERMISSION_TYPE?.CREATE,
    permissions,
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const roles = exportFilter?.role?.length
      ? exportFilter?.role
      : STAFF_ROLE_KEYS;
    const res = await requestUserExport({
      variables: {
        data: {
          type:
            roles?.length === 1
              ? EXPORT_TYPES?.[roles?.[0]]
              : EXPORT_TYPES?.LIBRARY_STAFF,
        },
        filter: {
          search: exportFilter?.search,
          roles,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          isActive: exportFilter?.status,
          staffLibraryIds: exportFilter?.library?.length
            ? exportFilter?.library
            : undefined,
          isArchived: exportFilter?.isArchived,
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  const headerButtons = (
    <>
      {canCreate && (
        <Button
          className="common-button"
          size="middle"
          icon={<PlusOutlined />}
          onClick={() => history?.push(`${LIBRARY_STAFF_BASE_PATH}/add`)}
        >
          Add New Staff
        </Button>
      )}
      <Button
        className="common-button ml-16"
        size="middle"
        icon={<ExportOutlined />}
        onClick={() => setIsModalOpen(true)}
        loading={isExportLoading}
      >
        Export
      </Button>
    </>
  );

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.LIBRARY_STAFF}</div>
      </Portal>
      <Portal portalId="header-right-content">{headerButtons}</Portal>
      <Portal portalId="header-right-content-phones">{headerButtons}</Portal>
      <ResetFilterButton tableKey={LIBRARY_STAFF_TABLE_FILTER_KEY} />
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <Card className="full-height-without-nav">
        <StaffTable
          exportFilter={exportFilter}
          setExportFilter={setExportFilter}
        />
      </Card>
    </>
  );
};

export default Staff;
